import React, { useEffect, useState } from "react"
import { Card, CardBody, Progress, Badge, Button } from "reactstrap"
import { getCurrentSubscription } from "../../../helpers/fakebackend_helper"
import moment from "moment"
import { Link } from "react-router-dom"

const SubscriptionWidget = () => {
    const [subscription, setSubscription] = useState(null)
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        loadSubscription()
    }, [])

    const loadSubscription = async () => {
        try {
            const data = await getCurrentSubscription()
            setSubscription(data)
        } catch (error) {
            console.error("Error loading subscription:", error)
        } finally {
            setLoading(false)
        }
    }

    if (loading) return null

    if (!subscription) {
        return (
            <Card>
                <CardBody>
                    <h4 className="card-title mb-4">Mon Abonnement</h4>
                    <div className="text-center py-4">
                        <i className="mdi mdi-alert-circle-outline text-warning font-size-48 d-block mb-3"></i>
                        <p>Aucun abonnement actif</p>
                        <Link to="/upgrade" className="btn btn-primary btn-sm">
                            <i className="mdi mdi-rocket me-1"></i>
                            Choisir un Plan
                        </Link>
                    </div>
                </CardBody>
            </Card>
        )
    }

    const getStatusBadge = (status) => {
        switch (status) {
            case 'pending_payment':
                return <Badge color="warning" className="font-size-12">En Attente de Paiement</Badge>
            case 'active':
                return <Badge color="success" className="font-size-12">Actif</Badge>
            case 'expired':
                return <Badge color="danger" className="font-size-12">Expiré</Badge>
            default:
                return <Badge color="secondary" className="font-size-12">{status}</Badge>
        }
    }

    const calculateUsagePercentage = (used, limit) => {
        if (!limit || limit === 0) return 0
        return Math.min((used / limit) * 100, 100)
    }

    const getProgressColor = (percentage) => {
        if (percentage >= 90) return "danger"
        if (percentage >= 70) return "warning"
        return "success"
    }

    return (
        <Card className="border">
            <CardBody>
                <div className="d-flex align-items-center justify-content-between mb-3">
                    <h4 className="card-title mb-0">
                        <i className="mdi mdi-credit-card-outline me-2"></i>
                        Mon Abonnement
                    </h4>
                    {getStatusBadge(subscription.status)}
                </div>

                {subscription.status === 'pending_payment' ? (
                    <div className="alert alert-warning">
                        <i className="mdi mdi-alert-outline me-2"></i>
                        <strong>Paiement en attente</strong>
                        <p className="mb-0 mt-2">
                            Nous n'avons pas encore reçu votre paiement. Votre compte sera activé dès réception.
                        </p>
                        <Link to="/payment-instructions" className="btn btn-sm btn-warning mt-2">
                            <i className="mdi mdi-information-outline me-1"></i>
                            Voir Instructions
                        </Link>
                    </div>
                ) : (
                    <>
                        <div className="mb-3">
                            <div className="d-flex justify-content-between mb-2">
                                <span className="text-muted">Plan Actuel</span>
                                <strong className="text-primary">{subscription.plan?.name}</strong>
                            </div>
                            <div className="d-flex justify-content-between">
                                <span className="text-muted">Expire le</span>
                                <strong>{moment(subscription.ends_at).format("DD MMMM YYYY")}</strong>
                            </div>
                        </div>

                        <hr />

                        <div className="mb-3">
                            <h6 className="font-size-13 text-muted mb-3">Utilisation</h6>

                            {/* Customers */}
                            {subscription.plan?.customer_limit && subscription.plan.customer_limit > 0 && (
                                <div className="mb-3">
                                    <div className="d-flex justify-content-between mb-1">
                                        <small>Clients</small>
                                        <small className="text-muted">
                                            {subscription.customer_count || 0} / {subscription.plan.customer_limit}
                                        </small>
                                    </div>
                                    <Progress
                                        value={calculateUsagePercentage(subscription.customer_count, subscription.plan.customer_limit)}
                                        color={getProgressColor(calculateUsagePercentage(subscription.customer_count, subscription.plan.customer_limit))}
                                        className="progress-sm"
                                    />
                                </div>
                            )}

                            {/* Email Credits */}
                            {subscription.plan?.email_credits && (
                                <div className="mb-3">
                                    <div className="d-flex justify-content-between mb-1">
                                        <small>Messages Email</small>
                                        <small className="text-muted">
                                            {subscription.email_credits_used || 0} / {subscription.plan.email_credits}
                                        </small>
                                    </div>
                                    <Progress
                                        value={calculateUsagePercentage(subscription.email_credits_used, subscription.plan.email_credits)}
                                        color={getProgressColor(calculateUsagePercentage(subscription.email_credits_used, subscription.plan.email_credits))}
                                        className="progress-sm"
                                    />
                                </div>
                            )}

                            {/* WhatsApp Credits */}
                            {subscription.plan?.whatsapp_credits && (
                                <div className="mb-2">
                                    <div className="d-flex justify-content-between mb-1">
                                        <small>Messages WhatsApp</small>
                                        <small className="text-muted">
                                            {subscription.whatsapp_credits_used || 0} / {subscription.plan.whatsapp_credits}
                                        </small>
                                    </div>
                                    <Progress
                                        value={calculateUsagePercentage(subscription.whatsapp_credits_used, subscription.plan.whatsapp_credits)}
                                        color={getProgressColor(calculateUsagePercentage(subscription.whatsapp_credits_used, subscription.plan.whatsapp_credits))}
                                        className="progress-sm"
                                    />
                                </div>
                            )}
                        </div>

                        <div className="d-grid gap-2">
                            <Link to="/upgrade" className="btn btn-primary btn-sm">
                                <i className="mdi mdi-arrow-up-bold-circle-outline me-1"></i>
                                Passer au Plan Supérieur
                            </Link>
                        </div>
                    </>
                )}
            </CardBody>
        </Card>
    )
}

export default SubscriptionWidget
